<template>
  <v-app-bar app>
    <v-app-bar-nav-icon  @click.stop="toggleNavigation" />
    <v-toolbar-title>{{ header }}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <v-btn
        v-if="$vuetify.breakpoint.lgAndUp && hasUsersAccess"
        color="primary"
        :to="{ name: 'users-list', params: { page: '1' } }"
        class="mr-10"
        text
      >
        <v-icon class="mr-2">account_circle</v-icon>
        {{ $t('USERS') }}
      </v-btn>
      <v-btn
        v-if="$vuetify.breakpoint.lgAndUp && hasGroupsAccess"
        color="primary"
        :to="{ name: 'groups-list', params: { page: '1' } }"
        class="mr-10"
        text
      >
        <v-icon class="mr-2">account_circle</v-icon>
        {{ $t('USERS_GROUPS') }}
      </v-btn>
      <v-auth
        :authorized-roles="[roles.ROLE_SETTINGS_MANAGER]"
      >
        <v-btn
          class="pl-2 settings-button"
          icon
          @click="goToSettings"
        >
          <v-icon class="mr-2">settings</v-icon>
        </v-btn>
      </v-auth>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon> account_circle </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item @click="handleMyProfile">
            <v-list-item-avatar><v-icon>account_box</v-icon></v-list-item-avatar>
            <v-list-item-title class="mr-10">
              {{ $t('MY_PROFILE') }}
              <div class="font-weight-light">{{ login }}</div>
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="handleLogout">
            <v-list-item-avatar><v-icon>exit_to_app</v-icon></v-list-item-avatar>
            <v-list-item-title class="mr-10">{{ $t('LOG_OUT') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import { AuthService } from '@/utils/services/auth-service';
  import VAuth from '@/components/__base/VAuth';
  import * as roles from '../../utils/user-roles';

  export default {
    name: 'TheHeader',
    components: { VAuth },
    data() {
      return {
        roles,
      };
    },
    computed: {
      ...mapState('auth', ['userRoles', 'login']),

      header() {
        return this.$route.meta.header;
      },

      hasUsersAccess() {
        return (
          this.userRoles.includes(this.roles.ROLE_USER_MANAGER) ||
          this.userRoles.includes(this.roles.ROLE_ROOT)
        );
      },

      hasGroupsAccess() {
        return (
          this.userRoles.includes(this.roles.ROLE_GROUP_MANAGER) ||
          this.userRoles.includes(this.roles.ROLE_ROOT)
        );
      },
    },
    methods: {
      ...mapActions('auth', ['destroySession']),

      toggleNavigation() {
        this.$emit('toggle-navigation');
      },

      handleLogout() {
        AuthService.logout()
          .then(() => {
            this.destroySession();
            this.$router.push({ path: '/login' });
            this.$socket.disconnect();
          })
          .catch(err => {
            console.error(err);
          });
      },

      handleMyProfile() {
        this.$router.push({ path: '/profile' });
      },

      goToSettings() {
        this.$router.push({ path: '/settings' });
      },
    },
  };
</script>

<style lang="scss">
  .settings-button {
    height: 100% !important;
    border-radius: 0 !important;
  }
</style>
